<template>
    <div class="flex-column jc-center py-5 px-9 fixed">
        <SaasIcon icon="svgDiscussionCheckbox" width="134" height="105" />
        <h2>{{ $l10n.__('Autorisation de l’ADV obligatoire') }}</h2>
        <h5 class="bold my-2">
            {{
                $l10n.__(
                    'Le montant de la nouvelle offre est inférieur à celui de l’abonnement en cours.',
                )
            }}
        </h5>
        <p class="fs-3 my-0">
            {{
                $l10n.__(
                    'Avant d’envoyer l’offre au client, assurez-vous que le montant de la nouvelle offre a bien été autorisé par l’administrateur des ventes Sellsy.',
                )
            }}
        </p>

        <CompassButton
            :label="$t.__('pages.account.upsell.AdvAuthorization.understood')"
            type="primary"
            class="mt-4 flex-item-left"
            @click="closeAdvAlert"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';
const upsellCart = createNamespacedHelpers('upsellCart');
export default {
    components: {
        SaasIcon,
    },
    methods: {
        ...upsellCart.mapActions(['closeAdvAlert']),
    },
};
</script>
